import React, { createContext, useContext, useState, useEffect } from 'react';

const NavigationContext = createContext();

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};

export const NavigationProvider = ({ children }) => {
  const [isNavigationModalOpen, setIsNavigationModalOpen] = useState(false);

  const openNavigationModal = () => {
    setIsNavigationModalOpen(true);
  };

  const closeNavigationModal = () => {
    setIsNavigationModalOpen(false);
  };

  const toggleNavigationModal = () => {
    setIsNavigationModalOpen(prev => !prev);
  };

  // Global keyboard shortcut listener
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Only handle Ctrl+M when modal is closed to avoid conflicts
      if (!isNavigationModalOpen && (event.ctrlKey || event.metaKey) && event.key === 'm') {
        event.preventDefault();
        toggleNavigationModal();
      }
    };

    // Add event listener
    document.addEventListener('keydown', handleKeyDown);

    // Cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isNavigationModalOpen]);

  const value = {
    isNavigationModalOpen,
    openNavigationModal,
    closeNavigationModal,
    toggleNavigationModal,
  };

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};
